import {CSSProperties, FC} from 'react';


export interface IIconVideoGreyProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconVideoGrey: FC<IIconVideoGreyProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 36 36"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M18 2.25a15.75 15.75 0 1 1 0 31.5 15.75 15.75 0 0 1 0-31.5Zm0 29.25a13.5 13.5 0 1 0 0-27 13.5 13.5 0 0 0 0 27Zm-1.688-8.705L23.506 18l-7.194-4.795v9.59Zm.374-12.047 8.77 5.848a1.688 1.688 0 0 1 0 2.808l-8.77 5.848a1.687 1.687 0 0 1-2.623-1.404V12.15a1.687 1.687 0 0 1 2.623-1.404v.002Z" />
        </svg>
    );
};
